import Vue       from 'vue';
import App       from './App.vue';
import router    from './router';
import store     from './store';
import axios     from 'axios';
import mixins    from './mixins.js';
import Vuelidate from 'vuelidate';

import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';
import 'jquery';
import 'popper.js';
import 'bootstrap';
import  vSelect from 'vue-select'
import {
  BasicDropdown,
  BasicTextInput,
  Checkbox,
	CheckboxInline,
  CurrencyInput,
  Datepicker,
  PercentInput,
  PhoneNumberInput,
  SelectInput,
  StateSelect,
  TextAreaInput,
  TextInputWithRightHeader,
  ToggleSwitch,
  ZipCodeInput,
  RoleSelect,
	UserTypeSelect,
  ManagerSelect,
  SalesRepSelect,
  ColleagueSelect,
  FileInput,
  Modal,
} from '@/components'

Vue.config.productionTip = false;

let componentsArray = [
  BasicDropdown,
  BasicTextInput,
  Checkbox,
	CheckboxInline,
  CurrencyInput,
  Datepicker,
  PercentInput,
  PhoneNumberInput,
  SelectInput,
  StateSelect,
  TextAreaInput,
  TextInputWithRightHeader,
  ToggleSwitch,
  ZipCodeInput,
  RoleSelect,
	UserTypeSelect,
  ManagerSelect,
  SalesRepSelect,
  ColleagueSelect,
  FileInput,
  Modal,
]
// Globally Registering these base components so we don't have to import them into every view/component
// Just make sure you reference them as.. ex: <BasicDropdown />  or  <basic-dropdown />
componentsArray.forEach(c => {
  //looping through every component
  Vue.component(`${c.name}`, c);
})

// Vue.component('BasicDropdown',            () => import('@/components'));
// Vue.component('BasicTextInput',           BasicTextInput);
// Vue.component('Checkbox',                 () => import('@/components/inputComponents/Checkbox.vue'));
// Vue.component('CurrencyInput',            () => import('@/components/inputComponents/CurrencyInput.vue'));
// Vue.component('Datepicker',               () => import('@/components/inputComponents/DatepickerCustom.vue'));
// Vue.component('PercentInput',             () => import('@/components/inputComponents/PercentInput.vue'));
// Vue.component('PhoneNumberInput',         () => import('@/components/inputComponents/PhoneNumberInput.vue'));
// Vue.component('SelectInput',              () => import('@/components/inputComponents/SelectInput.vue'));
// Vue.component('StateSelect',              () => import('@/components/inputComponents/StateSelect.vue'));
// Vue.component('TextAreaInput',            () => import('@/components/inputComponents/TextAreaInput.vue'));
// Vue.component('TextInputWithRightHeader', () => import('@/components/inputComponents/TextInputWithRightHeader.vue'));
// Vue.component('ToggleSwitch',             () => import('@/components/inputComponents/ToggleSwitch.vue'));
// Vue.component('ZipCodeInput',             () => import('@/components/inputComponents/ZipCodeInput.vue'));
// Vue.component('RoleSelect',               () => import('@/components/inputComponents/RoleSelect.vue'));
// Vue.component('ManagerSelect',            () => import('@/components/inputComponents/ManagerSelect.vue'));
// Vue.component('SalesRepSelect',           () => import('@/components/inputComponents/SalesRepSelect.vue'));
// Vue.component('ColleagueSelect',          () => import('@/components/inputComponents/ColleagueSelect.vue'));
// Vue.component('FileInput',                () => import('@/components/inputComponents/FileInput.vue'));

// Vue.component('Modal',                    () => import('@/components/Modal.vue'));

Vue.component('v-select', vSelect);

Vue.use(Vuelidate);

// Inject axios into Vue components as $axios
Vue.prototype.$axios = axios;

new Vue({
  router,
  store,
  mixins: mixins,
  render: h => h(App)
}).$mount('#app');
let avoidDuplicateMessages = true;
let avoidDuplicateLogoutAlerts = true
function resetTimer(){
  avoidDuplicateMessages = true
  avoidDuplicateLogoutAlerts = true
}
axios.interceptors.request.use(config => {
  let excludedUrl =
		config.url.includes('SystemConfig/SystemAnnouncement')
		|| config.url.includes('account/logout')
		|| config.url.includes('account/login')
		|| config.url.includes('/notifications');

	if(avoidDuplicateMessages && !excludedUrl){
    store.dispatch('GET_ALERT_MESSAGE');
    store.dispatch('GET_USER_NOTIFICATIONS');
    avoidDuplicateMessages = false;
    setTimeout(() => {
      resetTimer();
    }, 10000);
  } 
  if(!config.isDataSourceRequest) 
  {
    store.commit('ADD_REQUEST');
  }
  return config;
},  (err) => {
  console.error('Request error:', err)
  if(!err.config.isDataSourceRequest) store.commit('REMOVE_REQUEST');
  return Promise.reject(err);
});

axios.interceptors.response.use(response => {
  if(!response.config.isDataSourceRequest) store.commit('REMOVE_REQUEST');
  return response;
},(err) => {
  if(!err.config.isDataSourceRequest) store.commit('REMOVE_REQUEST');
  if (err.response && (err.response.status === 403 || err.response.status === 401)) {
    let errUrl = err.config.url.includes('systemConfig/SystemAnnouncement')
    let isLoggingOut = store.state.isLoggingOut

    // List of URLs that should not trigger the "account being used elsewhere" message
    let excludedUrls = [
      'account/logout',
      'account/users/current',
      'notifications',
      'systemConfig/SystemAnnouncement'
    ];

    let isExcludedUrl = excludedUrls.some(url => err.config.url.includes(url));

    // Don't log console errors for expected authentication failures on excluded URLs
    if (!isExcludedUrl) {
      console.error('Authentication error:', err);
    }

    if(err.response.status === 403 && !isExcludedUrl && !isLoggingOut && avoidDuplicateLogoutAlerts){
      avoidDuplicateLogoutAlerts = false;
      setTimeout(() => {
        resetTimer();
      }, 5000);
      store.dispatch('ADD_NOTIFICATION', { text: "You were logged off because your account is being used elsewhere", type: 'error' });
    }
    if(!errUrl) store.dispatch('AUTH_LOGOUT');
  } else {
    // Log other types of errors
    console.error('API error:', err);
  };
  return Promise.reject(err);
});

axios.interceptors.response.use(
    response => { return response; },
    error => {
      // Don't log expected authentication errors for certain endpoints
      let excludedUrls = [
        'account/logout',
        'account/users/current',
        'notifications',
        'systemConfig/SystemAnnouncement'
      ];

      let isExcludedUrl = excludedUrls.some(url => error.config && error.config.url.includes(url));
      let isAuthError = error.response && (error.response.status === 403 || error.response.status === 401);

      if (!(isAuthError && isExcludedUrl)) {
        console.error('Response error:', error);
      }

      if (
          error.request.responseType === 'blob' &&
          error.response.data instanceof Blob &&
          error.response.data.type &&
          error.response.data.type.toLowerCase().indexOf('json') != -1
      )
      {
        return new Promise((resolve, reject) => {
          let reader = new FileReader();
          reader.onload = () => {
            error.response.data = JSON.parse(reader.result);
            resolve(Promise.reject(error));
          };

          reader.onerror = () => {
            reject(error);
          };

          reader.readAsText(error.response.data);
        });
      };

      return Promise.reject(error);
    }
);
